// Copied verbatim (structure) from
// pinpointedu/frontend/apps/product/src/next/app/navigation/viewportBand.ts.
// Bands per docs/canonical/responsive-web-ui-system.md: mobile < 720,
// tablet 720-999, desktop >= 1000 CSS pixels.
export type ShellViewportBand = 'mobile' | 'tablet' | 'desktop';

export const MOBILE_MAX_WIDTH = 719;
export const DESKTOP_MIN_WIDTH = 1000;

export function viewportBandForWidth(
  width: number,
  desktopMin: number = DESKTOP_MIN_WIDTH,
  mobileMax: number = MOBILE_MAX_WIDTH,
): ShellViewportBand {
  if (width >= desktopMin) return 'desktop';
  if (width <= mobileMax) return 'mobile';
  return 'tablet';
}
